export default __webpack_public_path__ + "static/2010-secol-worthy-of-attention-collostruction-3df141eacdcc2db2d84a6824f783fec6.pdf";